export default {
    LOAD_STORE_SHIPPINGS (state, storeshippings) {
        state.items = storeshippings
    }
}